"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyFeatureForType = exports.default = exports.PropertyFeatureKeys = void 0;
var _values = _interopRequireDefault(require("lodash/values"));
var _concat = _interopRequireDefault(require("lodash/concat"));
var _listingType = _interopRequireWildcard(require("./listing-type"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var PropertyFeatureKeys = exports.PropertyFeatureKeys = ['A_GRADE_BUILDING', 'AIR_CONDITIONING', 'ALARM', 'BODY_CORPORATE', 'CARPORT_SPACES', 'CENTRAL_HEAT', 'COLD_SHELL', 'CORE_AREA', 'DEDICATED_PARKING', 'DINING_ROOM', 'DISABILITY_FRIENDLY', 'DISABLED_ACCESS', 'DUAL_ACCESS', 'ENSUITES', 'EXHAUST_FIT_OUT', 'EXHAUST_POINT', 'FAMILY_ROOM', 'GARAGE', 'GREASE_TRAP', 'HARD_STAND_AREA', 'HEAVY_VEHICLE_ACCESS', 'HIGH_CLEARANCE', 'LOADING_DOCK', 'NATURAL_LIGHT', 'NEW_CONSTRUCTION', 'NON_STRATA', 'OFF_STREET_PARKING', 'OUTDOOR_AREA', 'OVER_FIFTY_FIVE', 'OVER_SIXTY', 'PETS_ALLOWED', 'RUMPUS_ROOM', 'SELF_CONTAINED_FLAT', 'STRATA', 'STREET_FRONTAGE', 'STUDY', 'SUNROOM', 'SWIMMING_POOL', 'UNDERGROUND_PARKING', 'UV_BARGAIN', 'WARM_SHELL', 'FULLY_FURNISHED'];
var PropertyFeatureValues = {
  A_GRADE_BUILDING: {
    name: 'A_GRADE_BUILDING',
    label: 'A-grade Building',
    urlSlug: 'a-grade-building',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: false
  },
  AIR_CONDITIONING: {
    name: 'AIR_CONDITIONING',
    label: 'Air Conditioning',
    urlSlug: 'air-conditioning',
    listingTypes: (0, _concat.default)(_listingType.ResidentialListingTypeKeys, _listingType.CommercialListingTypeKeys),
    inUse: true
  },
  ALARM: {
    name: 'ALARM',
    label: 'Alarm',
    urlSlug: 'alarm',
    listingTypes: (0, _concat.default)(_listingType.ResidentialListingTypeKeys, _listingType.CommercialListingTypeKeys),
    inUse: true
  },
  BODY_CORPORATE: {
    name: 'BODY_CORPORATE',
    label: 'Body Corporate',
    urlSlug: 'body-corporate',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: false
  },
  CARPORT_SPACES: {
    name: 'CARPORT_SPACES',
    label: 'Carport Spaces',
    urlSlug: 'carport',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: false
  },
  CENTRAL_HEAT: {
    name: 'CENTRAL_HEAT',
    label: 'Central Heating',
    urlSlug: 'central-heating',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: true
  },
  COLD_SHELL: {
    name: 'COLD_SHELL',
    label: 'Cold Shell',
    urlSlug: 'cold-shell',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: false
  },
  CORE_AREA: {
    name: 'CORE_AREA',
    label: 'Core Area',
    urlSlug: 'core-area',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: false
  },
  DEDICATED_PARKING: {
    name: 'DEDICATED_PARKING',
    label: 'Dedicated Parking',
    urlSlug: 'dedicated-parking',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: true
  },
  DINING_ROOM: {
    name: 'DINING_ROOM',
    label: 'Dining Room',
    urlSlug: 'dining-room',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: false
  },
  DISABILITY_FRIENDLY: {
    name: 'DISABILITY_FRIENDLY',
    label: 'Disability Friendly',
    urlSlug: 'disabilty-friendly',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: true
  },
  DISABLED_ACCESS: {
    name: 'DISABLED_ACCESS',
    label: 'Disabled Access',
    urlSlug: 'disabled-access',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: false
  },
  DUAL_ACCESS: {
    name: 'DUAL_ACCESS',
    label: 'Dual Access',
    urlSlug: 'dual-access',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: false
  },
  ENSUITES: {
    name: 'ENSUITES',
    label: 'Ensuites',
    urlSlug: 'ensuites',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: true
  },
  EXHAUST_FIT_OUT: {
    name: 'EXHAUST_FIT_OUT',
    label: 'Exhaust Fit Out',
    urlSlug: 'exhaust-fit-out',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: true
  },
  EXHAUST_POINT: {
    name: 'EXHAUST_POINT',
    label: 'Exhaust Point',
    urlSlug: 'exhaust-point',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: true
  },
  FAMILY_ROOM: {
    name: 'FAMILY_ROOM',
    label: 'Family Room',
    urlSlug: 'family-room',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: false
  },
  GARAGE: {
    name: 'GARAGE',
    label: 'Garage',
    urlSlug: 'garage',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: false
  },
  GREASE_TRAP: {
    name: 'GREASE_TRAP',
    label: 'Grease Trap',
    urlSlug: 'grease-trap',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: false
  },
  HARD_STAND_AREA: {
    name: 'HARD_STAND_AREA',
    label: 'High Stand Area',
    urlSlug: 'high-stand-area',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: false
  },
  HEAVY_VEHICLE_ACCESS: {
    name: 'HEAVY_VEHICLE_ACCESS',
    label: 'Heavy Vehicle Access',
    urlSlug: 'heavy-vehicle-access',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: true
  },
  HIGH_CLEARANCE: {
    name: 'HIGH_CLEARANCE',
    label: 'High Clearance',
    urlSlug: 'high-clearance',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: false
  },
  LOADING_DOCK: {
    name: 'LOADING_DOCK',
    label: 'Loading Dock',
    urlSlug: 'loading-dock',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: true
  },
  NATURAL_LIGHT: {
    name: 'NATURAL_LIGHT',
    label: 'Natural Light',
    urlSlug: 'natural-light',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: false
  },
  NEW_CONSTRUCTION: {
    name: 'NEW_CONSTRUCTION',
    label: 'New Construction',
    urlSlug: 'new-construction',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: false
  },
  NON_STRATA: {
    name: 'NON_STRATA',
    label: 'Non-strata',
    urlSlug: 'non-strata',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: false
  },
  OFF_STREET_PARKING: {
    name: 'OFF_STREET_PARKING',
    label: 'Off-street Parking',
    urlSlug: 'off-street-parking',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: false
  },
  OUTDOOR_AREA: {
    name: 'OUTDOOR_AREA',
    label: 'Outdoor Area',
    urlSlug: 'outdoor-area',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: true
  },
  OVER_FIFTY_FIVE: {
    name: 'OVER_FIFTY_FIVE',
    label: 'Over 55s',
    urlSlug: 'over-55s',
    listingTypes: [_listingType.default.SALES_RESIDENTIAL.name, _listingType.default.RENTAL_RESIDENTIAL.name, _listingType.default.DEVELOPMENTS_RESIDENTIAL.name],
    inUse: true
  },
  OVER_SIXTY: {
    name: 'OVER_SIXTY',
    label: 'Over 60s',
    urlSlug: 'over-60s',
    listingTypes: [_listingType.default.SALES_RESIDENTIAL.name, _listingType.default.DEVELOPMENTS_RESIDENTIAL.name],
    inUse: false
  },
  PETS_ALLOWED: {
    name: 'PETS_ALLOWED',
    label: 'Pet Friendly',
    urlSlug: 'pets',
    listingTypes: [_listingType.default.RENTAL_RESIDENTIAL.name],
    inUse: true
  },
  RUMPUS_ROOM: {
    name: 'RUMPUS_ROOM',
    label: 'Rumpus Room',
    urlSlug: 'rumpus-room',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: false
  },
  SELF_CONTAINED_FLAT: {
    name: 'SELF_CONTAINED_FLAT',
    label: 'Self-contained Flat',
    urlSlug: 'flat',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: true
  },
  STRATA: {
    name: 'STRATA',
    label: 'Strata',
    urlSlug: 'strata',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: true
  },
  STREET_FRONTAGE: {
    name: 'STREET_FRONTAGE',
    label: 'Street Frontage',
    urlSlug: 'street-frontage',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: false
  },
  STUDY: {
    name: 'STUDY',
    label: 'Study',
    urlSlug: 'study',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: false
  },
  SUNROOM: {
    name: 'SUNROOM',
    label: 'Sunroom',
    urlSlug: 'sunroom',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: false
  },
  SWIMMING_POOL: {
    name: 'SWIMMING_POOL',
    label: 'Swimming Pool',
    urlSlug: 'pool',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: true
  },
  UNDERGROUND_PARKING: {
    name: 'UNDERGROUND_PARKING',
    label: 'Underground Parking',
    urlSlug: 'underground-parking',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: true
  },
  UV_BARGAIN: {
    name: 'UV_BARGAIN',
    label: 'UV Bargain',
    urlSlug: 'uv-bargain',
    listingTypes: _listingType.ResidentialListingTypeKeys,
    inUse: false
  },
  WARM_SHELL: {
    name: 'WARM_SHELL',
    label: 'Warm Shell',
    urlSlug: 'warm-shell',
    listingTypes: _listingType.CommercialListingTypeKeys,
    inUse: false
  },
  FULLY_FURNISHED: {
    name: 'FULLY_FURNISHED',
    label: 'Fully Furnished',
    urlSlug: 'fully-furnished',
    listingTypes: [_listingType.default.RENTAL_RESIDENTIAL.name],
    inUse: true
  }
};
var PropertyFeature = PropertyFeatureValues;
var getPropertyFeatureForType = listingType => (0, _values.default)(PropertyFeature).filter(each => each.listingTypes.includes(listingType) && each.inUse);
exports.getPropertyFeatureForType = getPropertyFeatureForType;
var _default = exports.default = PropertyFeature;